import { PlanType } from '@showbie-socrative/socrative-utils';
import { useAtomValue } from 'jotai';

import { selectedTeamIdAtom } from '~teacher/components/Account/atoms';
import { useSelectedTeamQuery } from '~teacher/components/Account/hooks';
import { useTeams } from '~teacher/hook/team';

export function useCurrentPlan() {
  const selectedTeamId = useAtomValue(selectedTeamIdAtom);
  const selectedTeam = useSelectedTeamQuery();
  return useTeams({
    select: (teams) => {
      const team = teams.find((t) => `${t.id}` === `${selectedTeamId}`);
      return team?.subscription?.plan ?? PlanType.Free;
    },
    enabled: !!selectedTeamId && !!selectedTeam.data,
  });
}
